import { useCallback, useState } from 'react'

const useToggle = (
  initialValue = false
): [
  boolean,
  (value?: any) => void,
  { turnOn: () => void; turnOff: () => void },
] => {
  const [value, setValue] = useState(initialValue)

  const toggle = useCallback((newValue?: any) => {
    if (typeof newValue === 'boolean') {
      setValue(newValue)
    } else {
      setValue((value) => !value)
    }
  }, [])

  const turnOn = useCallback(() => {
    setValue(true)
  }, [])

  const turnOff = useCallback(() => {
    setValue(false)
  }, [])

  return [value, toggle, { turnOn, turnOff }]
}

export default useToggle
